var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 22.0002C17.5228 22.0002 22 17.5231 22 12.0002C22 6.4774 17.5228 2.00024 12 2.00024C6.47715 2.00024 2 6.4774 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002Z","stroke":"#FEDA00","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2 12.0002H22","stroke":"#FEDA00","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12 2.00024C14.5013 4.7386 15.9228 8.29228 16 12.0002C15.9228 15.7082 14.5013 19.2619 12 22.0002C9.49872 19.2619 8.07725 15.7082 8 12.0002C8.07725 8.29228 9.49872 4.7386 12 2.00024V2.00024Z","stroke":"#FEDA00","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Globe.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Globe;

Globe.default = Globe;
